import { render, staticRenderFns } from "./MySchool.vue?vue&type=template&id=0e2dc6e1&scoped=true&"
import script from "./MySchool.vue?vue&type=script&lang=js&"
export * from "./MySchool.vue?vue&type=script&lang=js&"
import style0 from "./MySchool.vue?vue&type=style&index=0&id=0e2dc6e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2dc6e1",
  null
  
)

export default component.exports